import { useStore } from 'vuex';
import { nextTick } from 'vue';
import system from '@/store/modules/system';
import moment from 'moment';
const HolidayCalendar = require('holiday-calendar');
import { isHoliday } from 'china-holiday';

// 性别列表
const sexList = [
    {
        name: '男',
        value: '1'
    },
    {
        name: '女',
        value: '2'
    }
];

// 职位列表
const dutyList = [
    {
        name: 'LV10-销售专员',
        value: '10'
    },
    {
        name: 'LV20-区域负责人',
        value: '20'
    },
    {
        name: 'LV30-销售经理',
        value: '30'
    },
    {
        name: 'LV31-市场部经理',
        value: '31'
    },
    {
        name: 'LV40-营销负责人',
        value: '40'
    }
];

export const months = [
    {
        label: '一月份',
        value: 1,
        prop: 'month1'
    },
    {
        label: '二月份',
        value: 2,
        prop: 'month2'
    },
    {
        label: '三月份',
        value: 3,
        prop: 'month3'
    },
    {
        label: '四月份',
        value: 4,
        prop: 'month4'
    },
    {
        label: '五月份',
        value: 5,
        prop: 'month5'
    },
    {
        label: '六月份',
        value: 6,
        prop: 'month6'
    },
    {
        label: '七月份',
        value: 7,
        prop: 'month7'
    },
    {
        label: '八月份',
        value: 8,
        prop: 'month8'
    },
    {
        label: '九月份',
        value: 9,
        prop: 'month9'
    },
    {
        label: '十月份',
        value: 10,
        prop: 'month10'
    },
    {
        label: '十一月份',
        value: 11,
        prop: 'month11'
    },
    {
        label: '十二月份',
        value: 12,
        prop: 'month12'
    }
];

export const completeLink = {
    quota: {
        label: '指标',
        field: 'incomeTarget',
        rate: 'incomeTargetFinishRate'
    },
    budget: {
        label: '预算',
        field: 'incomeBudget',
        rate: 'incomeBudgetFinishRate'
    },
    forecast: {
        label: '预估',
        field: 'incomeForecast',
        rate: 'incomeForecastFinishRate'
    }
};

export const reputationCustomer = [
    {
        customerType: '公立客户',
        levelE: '逾期超6个月',
        levelD: '逾期6个月',
        levelC: '逾期4个月',
        levelB: '逾期2个月',
        levelA: '6个月账期内'
    },
    {
        customerType: '民营客户/企业',
        levelE: '逾期超6个月',
        levelD: '逾期6个月',
        levelC: '逾期4个月',
        levelB: '逾期2个月',
        levelA: '3个月账期内'
    }
];

export const reputationDoctor = [
    {
        levelType: '信用政策',
        levelA: '/',
        levelB: '签对账函',
        levelC: '发催款函',
        levelD: '二次催款函，视情况发律师函',
        levelE: '发律师函'
    }
];

export const demiss = [
    {
        value: 1,
        field: '',
        label: '一季度'
    },
    {
        value: 2,
        field: '',
        label: '二季度'
    },
    {
        value: 3,
        field: '',
        label: '三季度'
    },
    {
        value: 4,
        field: '',
        label: '四季度'
    },
    {
        value: 5,
        field: '',
        label: '半年度'
    },
    {
        value: 6,
        field: '',
        label: '全年度'
    }
];

export const demissMonth = [
    {
        value: 0,
        field: 'month1',
        label: '一季度'
    },
    {
        value: 1,
        field: 'month4',
        label: '二季度'
    },
    {
        value: 2,
        field: 'month7',
        label: '三季度'
    },
    {
        value: 3,
        field: 'month10',
        label: '四季度'
    }
];

export const filterMonth = [
    {
        label: '一月份',
        value: 1,
        field: 'month1'
    },
    {
        label: '二月份',
        value: 2,
        field: 'month2'
    },
    {
        label: '三月份',
        value: 3,
        field: 'month3'
    },
    {
        label: '四月份',
        value: 4,
        field: 'month4'
    },
    {
        label: '五月份',
        value: 5,
        field: 'month5'
    },
    {
        label: '六月份',
        value: 6,
        field: 'month6'
    },
    {
        label: '七月份',
        value: 7,
        field: 'month7'
    },
    {
        label: '八月份',
        value: 8,
        field: 'month8'
    },
    {
        label: '九月份',
        value: 9,
        field: 'month9'
    },
    {
        label: '十月份',
        value: 10,
        field: 'month10'
    },
    {
        label: '十一月份',
        value: 11,
        field: 'month11'
    },
    {
        label: '十二月份',
        value: 12,
        field: 'month12'
    }
];

export const accountAge = [
    {
        label: '1个月',
        value: 1,
        field: 'month1'
    },
    {
        label: '2个月',
        value: 2,
        field: 'month2'
    },
    {
        label: '3个月',
        value: 3,
        field: 'month3'
    },
    {
        label: '4个月',
        value: 4,
        field: 'month4'
    },
    {
        label: '5个月',
        value: 5,
        field: 'month5'
    },
    {
        label: '6个月',
        value: 6,
        field: 'month6'
    },
    {
        label: '7个月',
        value: 7,
        field: 'month7'
    },
    {
        label: '8个月',
        value: 8,
        field: 'month8'
    },
    {
        label: '9个月',
        value: 9,
        field: 'month9'
    },
    {
        label: '10个月',
        value: 10,
        field: 'month10'
    },
    {
        label: '11个月',
        value: 11,
        field: 'month11'
    },
    {
        label: '12个月',
        value: 12,
        field: 'month12'
    },
    {
        label: '1-2年',
        value: 13,
        field: 'year1'
    },
    {
        label: '2-3年',
        value: 14,
        field: 'year2'
    },
    {
        label: '3年以上',
        value: 15,
        field: 'year3'
    }
];

export const businessList = [
    {
        businessType: '普检',
        businessTypeCd: 1,
        isEdit: true
    },
    {
        businessType: '普检去年收入',
        businessTypeCd: 1,
        isEdit: false
    },
    {
        businessType: '公卫',
        businessTypeCd: 2,
        isEdit: true
    },
    {
        businessType: '公卫去年收入',
        businessTypeCd: 2,
        isEdit: false
    },
    {
        businessType: '特检',
        businessTypeCd: 3,
        isEdit: true
    },
    {
        businessType: '特检去年收入',
        businessTypeCd: 3,
        isEdit: false
    }
];

export const formatLabel = value => {
    return Number((value * 100).toFixed(0));
};

export const dealNum = rate => {
    return Number((rate * 100).toFixed(1)) > 100 ? 100 : Number((rate * 100).toFixed(1));
};

export const customColor = value => {
    let color = '';
    if (value >= 100) {
        color = '#F56C6C';
    } else if (value >= 80) {
        color = '#409EFF';
    } else if (value >= 70) {
        color = '#E6A23C';
    } else if (value >= 60) {
        color = 'rgb(209, 237, 196)';
    } else if (value >= 40) {
        color = 'rgb(179, 225, 157)';
    } else {
        color = '#67C23A';
    }
    return color;
};

const link = {
    gender: sexList,
    duty: dutyList
};

export const solveState = {
    0: 'info', // 待解决
    1: 'primary', // 解决中
    2: 'warning', // 待验证
    3: 'success', // 解决
    '-1': 'danger' // 无法解决
};

export const fileTypeList = {
    file1: { label: '对账函附件', value: 1 },
    file2: { label: '催账函附件', value: 2 },
    file3: { label: '回款计划书附件', value: 3 },
    file4: { label: '律师函附件', value: 4 },
    file8: { label: '关停函附件', value: 8 },
    file9: { label: '费用凭证', value: 9 },
    file10: { label: '其他附件', value: 10 },
    file11: { label: '案件附件', value: 11 }
};

export const filterName = (row, column) => {
    //
    let str = row[column.property];
    return link[column.property].filter(item => item.value == str)[0]?.name;
};

export const CheckQuery = (store, permission, initFn) => {
    store.dispatch('CheckQuery', permission);
    nextTick();
    if (store.state.app.isQuery) {
        initFn();
    }
};

export const looseEqual = (a, b) => {
    if (a === b) {
        //如果是绝对相等就直接返回true
        return true;
    }
    //如果不是绝对相等就哦按的他们是否有相同的形状
    var isObjectA = isObject(a);
    var isObjectB = isObject(b);
    if (isObjectA && isObjectB) {
        //两个均是对象
        try {
            var isArrayA = Array.isArray(a);
            var isArrayB = Array.isArray(b);
            if (isArrayA && isArrayB) {
                //如果都是数组
                if (a.length === b.length) {
                    //如果长度相等
                    return a.every(function (e, i) {
                        //用every和递归来比对a数组和b数组的每个元素，并返回
                        return looseEqual(e, b[i]);
                    });
                }
                //长度都不等直接返回false
                return false;
            } else if (a instanceof Date && b instanceof Date) {
                //如果是Date 则直接getTime 比较
                return a.getTime() === b.getTime();
            } else if (!isArrayA && !isArrayB) {
                //对象的比较
                //拿到两个对象的key
                var keysA = Object.keys(a);
                var keysB = Object.keys(b);
                if (keysA.length === keysB.length) {
                    //如果keys相等
                    return keysA.every(function (key) {
                        //用every和递归来比对a对象和b对象的每个元素值，并返回
                        return looseEqual(a[key], b[key]);
                    });
                }
                //长度都不等直接返回false
                return false;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    } else if (!isObjectA && !isObjectB) {
        //如果都不是对象则按String来处理
        return String(a) === String(b);
    } else {
        return false;
    }

    function isObject(obj) {
        return obj !== null && typeof obj === 'object';
    }
};

export const convertToUTF8 = (str, originalEncoding) => {
    // 假设我们知道原始编码是ISO-8859-1
    if (originalEncoding === 'ISO-8859-1') {
        // 使用TextEncoder进行转码
        const encoder = new TextEncoder();
        const originalBytes = encoder.encode(str);

        // 假设目标编码是UTF-8
        const targetEncoding = 'utf-8';

        // 这里可以使用任何库或自定义函数来转换编码
        // 这里我们假设有一个函数convertEncoding来处理编码转换
        const convertedBytes = convertEncoding(originalBytes, originalEncoding, targetEncoding);

        function convertEncoding(bytes, fromEncoding, toEncoding) {
            // 这里应该是将bytes从fromEncoding转换为toEncoding的逻辑
            // 但是这个逻辑需要你知道如何实现，这里只是一个占位符
            throw new Error('convertEncoding function not implemented');
        }
        // 使用TextDecoder将转换后的字节解码为字符串
        const decoder = new TextDecoder(targetEncoding);
        return decoder.decode(convertedBytes);
    }

    // 如果原始编码就是UTF-8，直接返回
    return str;
};

// 示例函数，实际中需要替换为具体的编码转换逻辑

export const floatNumber = (v, p = 2) => {
    if (!isNaN(v)) {
        return Number(v * 100).toFixed(p) + '%';
    } else {
        return '--';
    }
};

export const getList = () => {
    let list = [
        {
            name: '南京江宁',
            text: 'item1'
        },
        {
            name: '南京江宁',
            text: 'item2'
        },
        {
            name: '南京江宁',
            text: 'item2'
        },
        {
            name: '南京江宁',
            text: 'item2'
        },
        {
            name: '南京江宁',
            text: 'item2'
        },
        {
            name: '南京江宁',
            text: 'item2'
        },
        {
            name: '南京浦口',
            text: 'item2'
        },
        {
            name: '南京浦口',
            text: 'item2'
        },
        {
            name: '南京浦口',
            text: 'item2'
        },
        {
            name: '南京浦口',
            text: 'item2'
        },
        {
            name: '南京浦口',
            text: 'item2'
        },
        {
            name: '南京玄武',
            text: 'item2'
        },
        {
            name: '南京玄武',
            text: 'item2'
        },
        {
            name: '南京玄武',
            text: 'item2'
        },
        {
            name: '南京玄武',
            text: 'item2'
        }
    ];

    return list;
};

export const floatFormatter = (row, code) => {
    const { personalExpressionFactor } = row;
    let val = row[code];
    let info = personalExpressionFactor.find(item => item.factorCode == code);
    if (!_.isEmpty(info)) {
        return {
            type: val > info.standard ? '' : 'danger',
            value: floatNumber(val)
        };
    } else {
        return {
            type: '',
            value: floatNumber(val)
        };
    }
};

export const floatFormatterNum = (row, code) => {
    const { personalExpressionFactor } = row;
    let val = row[code];
    let info = personalExpressionFactor.find(item => item.factorCode == code);
    if (!_.isEmpty(info)) {
        return {
            type: val >= info.standard ? '' : 'danger',
            value: val
        };
    } else {
        return {
            type: '',
            value: val
        };
    }
};

export const formatNumber = (num, type = 1) => {
    // 将数字转换为字符串
    const str = num.toString();

    const pum = str.split('.')[0];

    let dw = '';

    let dw2 = '';
    // 检查数字长度
    if (pum.length < 5) {
        // 长度不足四位，不做转换
        return pum;
    }
    // 获取尾数
    let end = pum.slice(-4);

    let start = pum.slice(0, -4);

    let middle = '';

    let endnum = Number(end).toString();

    dw = type == '1' ? '万' : 'W';
    if (pum.length > 8) {
        dw = type == '1' ? '亿' : 'E';
        dw2 = type == '1' ? '万' : 'W';
        middle = pum.slice(-8, -4);
        start = pum.slice(0, -8);
        let middlenum = Number(middle).toString();
        return `${start}${dw}${middlenum}${dw2}${endnum}`;
    }
    // 拼接并返回结果
    return `${start}${dw}${endnum}`;
};

export const localeString = val => {
    if (val == undefined || _.isNaN(val)) return '';
    return val.toLocaleString('zh', { style: 'decimal', maximumFractionDigits: 2 });
};

export const localeAllString = val => {
    if (val == undefined || _.isNaN(val)) return '';
    return val.toLocaleString('zh', { style: 'decimal', maximumFractionDigits: 5 });
};

export const localeIntString = val => {
    if (val == undefined || _.isNaN(val)) return '';
    return val.toLocaleString('zh', { style: 'decimal' }).split('.')[0];
};

export const cellStyle = ({ row }) => {
    const { baseSum, developSum, increaseSum, publicSum } = row;
    const list = [baseSum, developSum, increaseSum, publicSum].filter(item => item);
    const len = list.length;
    return {
        height: len > 1 ? len * 28 + 'px' : '40px'
    };
};

export const renderChildren = list => {
    return list.map(item => {
        return {
            ...item,
            children:
                item.children || item.regionList
                    ? renderChildren(
                          item.children && item.children.length > 0
                              ? item.children
                              : item.regionList && item.regionList.length > 0
                              ? item.regionList.map(it => ({ ...it, areaId: 'v' + '-' + it.regionId, areaName: it.regionName }))
                              : []
                      )
                    : []
        };
    });
};

export const renderQuotaChildren = list => {
    return list.map(item => {
        const { increment, inventory, targetId } = item.regionId ? item.incomeTargetRegion ?? {} : item.incomeTargetArea ?? {};
        let children =
            item.children || item.regionList
                ? renderQuotaChildren(
                      item.children && item.children.length > 0
                          ? item.children
                          : item.regionList && item.regionList.length > 0
                          ? item.regionList.map(it => ({ ...it, areaId: 'v' + '-' + it.regionId, areaName: it.regionName }))
                          : []
                  )
                : [];
        return {
            ...item,
            increment,
            inventory,
            targetId,
            total: Number(increment ?? 0) + Number(inventory ?? 0),
            countIncrment:
                Number(increment ?? 0) -
                children.map(item => item.increment).reduce((acc, curr) => Number(acc ?? 0) + Number(curr ?? 0), 0),
            countInventory:
                Number(inventory ?? 0) -
                children.map(item => item.inventory).reduce((acc, curr) => Number(acc ?? 0) + Number(curr ?? 0), 0),
            children: children
        };
    });
};

export const renderStockList = list => {
    return list.map(item => {
        const { incomeTargetAreaList = [] } = item ?? {};
        let incrementInfo = incomeTargetAreaList.find(it => it.incomeTargetTypeCode == 1);
        let inventoryInfo = incomeTargetAreaList.find(it => it.incomeTargetTypeCode == 2);
        let ingongoryInfo = incomeTargetAreaList.find(it => it.incomeTargetTypeCode == 3);
        let children = renderStockList(item.children ?? []);
        return {
            ...item,
            increment: incrementInfo ? incrementInfo.value : 0,
            inventory: inventoryInfo ? inventoryInfo.value : 0,
            ingongory: ingongoryInfo ? ingongoryInfo.value : 0,
            num: ingongoryInfo ? ingongoryInfo.num : null,
            inventoryId: inventoryInfo ? inventoryInfo.id : null,
            ingongoryId: ingongoryInfo ? ingongoryInfo.id : null,
            inventoryFlag: inventoryInfo ? inventoryInfo.commitFlag : null,
            ingongoryFlag: ingongoryInfo ? ingongoryInfo.commitFlag : null,
            countInventory:
                Number(inventoryInfo ? inventoryInfo.value : 0) -
                children.map(item => item.inventory).reduce((acc, curr) => Number(acc ?? 0) + Number(curr ?? 0), 0),
            countIngongory:
                Number(ingongoryInfo ? ingongoryInfo.value : 0) -
                children.map(item => item.ingongory).reduce((acc, curr) => Number(acc ?? 0) + Number(curr ?? 0), 0),
            total: Number(incrementInfo ? incrementInfo.value : 0) + Number(inventoryInfo ? inventoryInfo.value : 0),
            // Number(ingongoryInfo ? ingongoryInfo.value : 0),
            children: children
        };
    });
};

export const renderUserList = list => {
    return list.map(item => {
        const { incomeTargetUserList = [] } = item ?? {};
        let incrementInfo = incomeTargetUserList.find(it => it.incomeTargetTypeCode == 1);
        let inventoryInfo = incomeTargetUserList.find(it => it.incomeTargetTypeCode == 2);
        let ingongoryInfo = incomeTargetUserList.find(it => it.incomeTargetTypeCode == 3);
        let children = renderStockList(item.children ?? []);
        return {
            ...item,
            increment: incrementInfo ? incrementInfo.value : null,
            inventory: inventoryInfo ? inventoryInfo.value : null,
            ingongory: ingongoryInfo ? ingongoryInfo.value : null,
            num: ingongoryInfo ? ingongoryInfo.num : null,
            inventoryId: inventoryInfo ? inventoryInfo.id : null,
            ingongoryId: ingongoryInfo ? ingongoryInfo.id : null,
            inventoryFlag: inventoryInfo ? inventoryInfo.commitFlag : null,
            ingongoryFlag: ingongoryInfo ? ingongoryInfo.commitFlag : null,
            countInventory:
                Number(inventoryInfo ? inventoryInfo.value : 0) -
                children.map(item => item.inventory).reduce((acc, curr) => Number(acc ?? 0) + Number(curr ?? 0), 0),
            countIngongory:
                Number(ingongoryInfo ? ingongoryInfo.value : 0) -
                children.map(item => item.ingongory).reduce((acc, curr) => Number(acc ?? 0) + Number(curr ?? 0), 0),
            countIncrement:
                Number(incrementInfo ? incrementInfo.value : 0) -
                children.map(item => item.increment).reduce((acc, curr) => Number(acc ?? 0) + Number(curr ?? 0), 0),
            total: Number(incrementInfo ? incrementInfo.value : 0) + Number(inventoryInfo ? inventoryInfo.value : 0),
            children: children
        };
    });
};

export const renderCooperateList = list => {
    return list.map(item => {
        const { incomeTargetAreaList = [] } = item ?? {};
        let incrementInfo = incomeTargetAreaList.find(it => it.incomeTargetTypeCode == 1);
        let ingongoryInfo = incomeTargetAreaList.find(it => it.incomeTargetTypeCode == 3);

        let children = renderStockList(item.children);
        return {
            ...item,
            increment: incrementInfo ? incrementInfo.value : 0,
            ingongory: ingongoryInfo ? ingongoryInfo.value : 0,
            num: ingongoryInfo ? ingongoryInfo.num : null,
            ingongoryId: ingongoryInfo ? ingongoryInfo.id : null,
            ingongoryFlag: ingongoryInfo ? ingongoryInfo.commitFlag : null,
            countIngongory:
                Number(ingongoryInfo ? ingongoryInfo.value : 0) -
                children.map(item => item.ingongory).reduce((acc, curr) => Number(acc ?? 0) + Number(curr ?? 0), 0),
            total: Number(incrementInfo ? incrementInfo.value : 0) + Number(ingongoryInfo ? ingongoryInfo.value : 0),
            children: children
        };
    });
};

export const renderCooperateUserList = list => {
    return list.map(item => {
        const { incomeTargetUserList = [] } = item ?? {};
        let incrementInfo = incomeTargetUserList.find(it => it.incomeTargetTypeCode == 1);
        let ingongoryInfo = incomeTargetUserList.find(it => it.incomeTargetTypeCode == 3);

        let children = renderCooperateUserList(item.children ?? []);
        return {
            ...item,
            increment: incrementInfo ? incrementInfo.value : 0,
            ingongory: ingongoryInfo ? ingongoryInfo.value : 0,
            num: ingongoryInfo ? ingongoryInfo.num : null,
            ingongoryId: ingongoryInfo ? ingongoryInfo.id : null,
            ingongoryFlag: ingongoryInfo ? ingongoryInfo.commitFlag : null,
            countIngongory:
                Number(ingongoryInfo ? ingongoryInfo.value : 0) -
                children.map(item => item.ingongory).reduce((acc, curr) => Number(acc ?? 0) + Number(curr ?? 0), 0),
            total: Number(incrementInfo ? incrementInfo.value : 0) + Number(ingongoryInfo ? ingongoryInfo.value : 0),
            children: children
        };
    });
};

export const renderMenu = (authRoute, menuAll) => {
    return authRoute
        .filter(item => menuAll.find(it => it.path == item.path && it.show))
        .map(item => {
            let menuItem = menuAll.find(it => it.path == item.path);
            return {
                ...item,
                icon: menuItem?.icon
            };
        });
};

export const flatMenu = list => {
    let arr = [];
    list.map(item => {
        arr.push(item);
        if (item.children) {
            arr.push(...item.children);
        }
    });
    return arr;
};

export const flateTree = list => {
    let result = [];
    function getData(list) {
        list.forEach(item => {
            result.push(item);
            if (item.children) {
                getData(item.children);
            }
        });
    }
    getData(list);
    return result;
};

export const flateLevelTree = list => {
    let result = [];
    function getData(list) {
        list.forEach(item => {
            const { children, ...params } = item;
            result.push({
                ...params,
                children: null
            });
            if (children) {
                getData(children);
            }
        });
    }
    getData(list);
    return result;
};

export const sortRenderList = (_l, _s = 'sort', _p = 'children') => {
    function _renderList(_l, _s, _p) {
        return (
            _l &&
            _l
                .sort((a, b) => a[_s] - b[_s])
                .map(item => {
                    return {
                        ...item,
                        [_p]: _renderList(item[_p] ?? [], _s, _p)
                    };
                })
        );
    }
    return _renderList(_l, _s, _p);
};

export const getQuotaData = list => {
    let arr = [];
    function renderChild(list) {
        list.map(item => {
            if (item.endFlag == 1) {
                arr.push(item);
            } else if (item.children.length > 0) {
                renderChild(item.children);
            }
        });
    }
    renderChild(list);
    return arr;
};

export const dealMonths = obj => {
    const { month1, month2, month3, month4, month5, month6, month7, month8, month9, month10, month11, month12 } = obj ?? {};
    return [month1, month2, month3, month4, month5, month6, month7, month8, month9, month10, month11, month12].map(item => item ?? 0);
};

export const dealMontha = obj => {
    const { month1, month2, month3, month4, month5, month6, month7, month8, month9, month10, month11, month12 } = obj ?? {};
    return [month1, month2, month3, month4, month5, month6, month7, month8, month9, month10, month11, month12];
};

export const getQuotaCurData = list => {
    let arr = [];
    function renderChild(list) {
        list.map(item => {
            if (item.endFlag == 1) {
                arr.push(...(item.children ?? []));
            } else if (item.children.length > 0) {
                renderChild(item.children);
            }
        });
    }
    renderChild(list);
    return arr;
};

export const renderSaveChildren = (list, year) => {
    return list.map(item => {
        return {
            targetId: item.targetId,
            year,
            [item.endFlag == 1 ? 'areaName' : 'regionName']: item.endFlag == 1 ? item.areaName : item.regionName,
            [item.endFlag == 1 ? 'areaId' : 'regionId']: item.endFlag == 1 ? item.areaId : item.regionId,
            inventory: item.inventory,
            increment: item.increment,
            countIncrment: item.countIncrment,
            countInventory: item.countInventory,
            regionList: renderSaveChildren(item.children, year)
        };
    });
};

export const renderCurretChildren = (list, year) => {
    return list.map(item => {
        return {
            targetId: item.targetId,
            year,
            regionName: item.regionName,
            regionId: item.regionId,
            inventory: item.inventory,
            increment: item.increment,
            countIncrment: item.countIncrment,
            countInventory: item.countInventory
        };
    });
};

export const renderRoutes = (assetRoute, authRoute, permissionList, router) => {
    authRoute.forEach(item => {
        let routeItem = assetRoute.find(it => it.path == item.path);
        if (!_.isEmpty(routeItem)) {
            let nRouteItem = {
                path: item.path,
                name: item.menuName,
                redirect: routeItem.children.length == 0 ? routeItem.redirect : routeItem.path + '/' + routeItem.children[0].path,
                component: routeItem.component,
                meta: routeItem.meta,
                children: []
            };
            item.children &&
                item.children.forEach(v => {
                    let isExit = routeItem.children.find(i => item.path + '/' + i.path == v.path);
                    if (
                        v.path == '/cust/home' &&
                        (permissionList.indexOf('cust:home:edit') != -1 || permissionList.indexOf('cust:home:super-edit') != -1)
                    ) {
                        let item = routeItem.children.find(im => im.path == 'edit');
                        nRouteItem.children.push(item);
                    }

                    if (v.path == '/cust/home' && permissionList.indexOf('cust:home:add') != -1) {
                        let item = routeItem.children.find(im => im.path == 'add');
                        nRouteItem.children.push(item);
                    }

                    if (v.path == '/organization/user' && permissionList.indexOf('organization:user:customer') != -1) {
                        let item = routeItem.children.find(im => im.path == 'authSetting');
                        nRouteItem.children.push(item);
                    }

                    if (!_.isEmpty(isExit)) {
                        isExit.name = v.menuName;
                        nRouteItem.children.push(isExit);
                    }
                });

            if (item.path == '/home') {
                nRouteItem.children.push(...routeItem.children);
            }
            router.addRoute(nRouteItem);
        }
    });
};

export const stateCode = ['21', '22'];

const menuBaseConfig = {
    organization: 'config:organization:',
    organizationV: '/config/organization',
    business: 'config:business:',
    system: 'config:system:',
    board: 'analyse:board:',
    analysis: 'analyse:analysis:',
    budget: 'receipts:budget:',
    quota: 'receipts:quota:',
    income: 'receipts:income:',
    forecast: 'receipts:forecast:',
    merits: 'performance:merits:',
    kpi: 'performance:kpi:',
    meritsConfig: 'performance:config:'
};

export const menuConfig = {
    organization: 'config:organization:',
    organizationV: '/config/organization',
    business: 'config:business:',
    system: 'config:system:',
    board: 'analyse:board:',
    analysis: 'analyse:analysis:',
    budget: 'receipts:budget:',
    quota: 'receipts:quota:',
    income: 'receipts:income:',
    forecast: 'receipts:forecast:',
    merits: 'performance:merits:',
    kpi: 'performance:kpi:',
    meritsConfig: 'performance:config:'
};

export const renderAuthRoute = (assetRoute, authRoute, permissionList, path = '') => {
    return assetRoute
        .filter(item => item.menuCode != 3)
        .map(item => {
            if (
                item.path == '/cust' &&
                (permissionList.indexOf('cust:home:edit') != -1 || permissionList.indexOf('cust:home:super-edit') != -1)
            ) {
                item.children.push({
                    path: '/cust/edit',
                    menuName: '客户编辑',
                    show: true
                });
            }
            if (item.path == '/cust' && permissionList.indexOf('cust:home:add') != -1) {
                item.children.push({
                    path: '/cust/add',
                    menuName: '客户新增',
                    show: true
                });
            }

            if (item.path == menuBaseConfig.organizationV && permissionList.indexOf(menuBaseConfig.organization + 'user:customer') != -1) {
                item.children.push({
                    path: menuBaseConfig.organizationV + '/authSetting',
                    menuName: '客户权限设置',
                    show: true
                });
            }

            if (item.path == '/flowable') {
                item.children.push({
                    path: '/flowable/translate-form',
                    menuName: '开发申请表单',
                    show: true
                });
                item.children.push({
                    path: '/flowable/applyDelayForm',
                    menuName: '延期申请表单',
                    show: true
                });
                item.children.push({
                    path: '/flowable/applyFeeForm',
                    menuName: '费用申请表单',
                    show: true
                });
                item.children.push({
                    path: '/flowable/applyFeeOutForm',
                    menuName: '费用申请表单(计划外)',
                    show: true
                });
                item.children.push({
                    path: '/flowable/additionalFeeForm',
                    menuName: '费用申请表单(追加)',
                    show: true
                });
                item.children.push({
                    path: '/flowable/applyReimburseForm',
                    menuName: '费用报销表单',
                    show: true
                });
                item.children.push({
                    path: '/flowable/submitOpportunityForm',
                    menuName: '商机评估表单',
                    show: true
                });
            }

            let routeItem = authRoute.find(it => {
                return path ? path + '/' + it.path == item.path : path + it.path == item.path;
            });
            if (!_.isEmpty(routeItem)) {
                let p = path ? path + '/' + routeItem.path : path + routeItem.path;
                return {
                    path: routeItem.path,
                    name: routeItem.name,
                    redirect:
                        routeItem.children && routeItem.children.length > 0 && routeItem.children[0].path
                            ? p + '/' + routeItem.children[0].path
                            : routeItem.redirect,
                    component: routeItem.component,
                    meta: { ...(routeItem.meta ?? {}), name: item.menuName },
                    children: renderAuthRoute(item.children ?? [], routeItem.children ?? [], permissionList, item.path)
                };
            } else {
                return {
                    path: item.path,
                    name: item.name,
                    redirect: '',
                    component: null,
                    meta: { name: item.menuName },
                    children: renderAuthRoute(item.children ?? [], [], permissionList, item.path)
                };
            }
        });
};

export const renderMenuTree = list => {
    return list.map(item => {
        return {
            menuId: item.menuId,
            menuName: item.menuName,
            parentId: item.parentId,
            children: item.children && item.children[0].menuType != '3' ? [] : item.children,
            childs: item.children && item.children[0].menuType != '3' ? renderMenuTree(item.children) : []
        };
    });
};

export const flatMenuList = arr => {
    let result = [];
    arr.forEach(item => {
        result.push({
            menuId: item.menuId,
            menuName: item.menuName,
            parentId: item.parentId
        });
        if (Array.isArray(item.children)) {
            result = result.concat(flatMenuList(item.children));
        }
    });
    return result;
};

export const dealTime = time => {
    if (time) {
        let startTime = moment(time, 'YYYY-MM-DD HH:mm:ss');
        let endTime = moment();
        let diffTime = endTime.diff(startTime);
        let dur = moment.duration(diffTime);
        let h = dur.asHours();

        return 1 < h
            ? h < 24
                ? Math.floor(h) + '小时前更新'
                : Math.floor(dur.asDays()) + '天前更新'
            : Math.floor(dur.asMinutes()) + '分钟前更新';
    } else {
        return '';
    }
};

export const statusMap = {
    0: 'info',
    1: 'primary',
    2: 'primary',
    3: 'success',
    4: 'danger',
    5: 'info',
    6: 'info',
    7: 'danger',
    8: 'success',
    9: 'danger',
    10: 'info',
    11: 'primary',
    12: 'primary'
};

export const homeCustomer = [
    {
        name: '已合作客户数量',
        prop: 'customerHasCooperationNum'
    },
    {
        name: '今年新开发的客户',
        prop: 'customerNewYearNum'
    },
    {
        name: '本月新开发的客户',
        prop: 'customerNewMonthNum'
    },
    {
        name: '今年开发中的客户',
        prop: 'customerDevelopYearNum'
    },
    {
        name: '本月要开发的客户(累计)',
        prop: 'customerDevelopMonthNum'
    }
];

export const homeIncome = [
    {
        name: '当月指标',
        prop: 'targetMonth'
    },
    {
        name: '当月收入（结算）',
        prop: 'incomeSettleMonth'
    },
    {
        name: '当月完成率（结算）',
        prop: 'incomeSettleFinishRateMonth'
    },
    {
        name: '今年指标（总）',
        prop: 'targetYear'
    },
    {
        name: '今年收入（财务）（总）',
        prop: 'incomeActualYear'
    },
    {
        name: '今年完成率（财务）（总）',
        prop: 'incomeActualFinishRateYear'
    },
    {
        name: '今年指标（累计到上月）',
        prop: 'targetYearAcc'
    },
    {
        name: '今年收入（累计到上月）（财务）',
        prop: 'incomeActualAcc'
    },
    {
        name: '今年完成率（累计到上月）（财务）',
        prop: 'incomeActualFinishRateAcc'
    },
    {
        name: '今年收入（财务）（新开发客户）',
        prop: 'incomeActualNewCustomerYear'
    }
];

export const homeReturn = [
    {
        name: '当月回款指标',
        prop: 'returnTargetMonth'
    },
    {
        name: '当月实际回款',
        prop: 'returnActualMonth'
    },
    {
        name: '当月回款完成率',
        prop: 'returnFinishRateMonth'
    }
];

export const homeVisit = [
    {
        name: '当月拜访计划数量',
        prop: 'returnTargetMonth'
    },
    {
        name: '当月拜访汇报数量',
        prop: 'returnActualMonth'
    }
];

export const unitConvert = (num, step = 1) => {
    var moneyUnits = ['', '万', '亿', '万亿'];
    var dividend = 10000;
    var curentNum = num;
    //转换数字
    var curentUnit = moneyUnits[0];
    var isAbs = num >= 0 ? false : true;

    let pn = Math.abs(curentNum).toString().split('.')[0];
    step = curentNum < 100000 ? 2 : 1;
    //转换单位
    for (var i = 0; i < 4; i++) {
        curentUnit = moneyUnits[i];
        if (curentNum < 0) {
            curentNum = Math.abs(curentNum);
        }
        if (strNumSize(curentNum) < (pn.length < 5 ? 4 : 5)) {
            break;
        }
        curentNum = curentNum / dividend;
    }
    var m = { num: 0, unit: '' };
    m.num = curentNum.toString().indexOf('.') > -1 ? (isAbs ? '-' : '') + curentNum.toFixed(step) : (isAbs ? '-' : '') + curentNum;
    m.unit = curentUnit;
    return m.num + m.unit;
};

function strNumSize(tempNum) {
    var stringNum = tempNum.toString();
    var index = stringNum.indexOf('.');
    var newNum = stringNum;
    if (index != -1) {
        newNum = stringNum.substring(0, index);
    }
    return newNum.length;
}

export const quotaColor = [
    {
        showType: 1,
        label: '基础',
        color: '#409EFF'
    },
    {
        showType: 2,
        label: '上量',
        color: 'rgb(250, 181.5, 181.5)'
    },
    {
        showType: 3,
        label: '滚动',
        color: 'rgb(179, 224.5, 156.5)'
    }
];

export const convertToCamelCase = str => {
    return str.toLowerCase().replace(/_(.)/g, function (match, group1) {
        return group1.toUpperCase();
    });
};

export const camelToSnake = camelCaseString => {
    return camelCaseString.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase();
};

export const chunkArray = (arr, size = 50) => {
    return arr.reduce((acc, curr, i) => {
        if (i % size === 0) acc.push([]);
        acc[acc.length - 1].push(curr);
        return acc;
    }, []);
};

export const getTextWidth = (text, font) => {
    // 创建一个临时的canvas元素
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    // 设置字体样式
    ctx.font = font || '14px Avenir, Helvetica, Arial, sans-serif';

    // 测量文本宽度
    const metrics = ctx.measureText(text);

    return metrics.width;
};

export const expEndDate = date => {
    return moment().format('YYYY-MM-DD') > date ? 'danger' : 'primary';
};

export const findDuplicates = arr => {
    const countMap = arr.reduce((acc, el) => {
        acc[el] = acc[el] ? acc[el] + 1 : 1;
        return acc;
    }, {});

    return Object.keys(countMap).filter(key => countMap[key] > 1);
};

export const colorList = [
    '#409EFF',
    '#79bbff',
    '#c6e2ff',
    '#95d475',
    '#b3e19d',
    '#d1edc4',
    '#eebe77',
    '#f3d19e',
    '#f8e3c5',
    '#f89898',
    '#fab6b6',
    '#fcd3d3'
];

export const graphData = {
    id: 'Modeling Methods',
    children: [
        {
            id: 'Classification',
            children: [
                {
                    id: 'Logistic regression'
                },
                {
                    id: 'Linear discriminant analysis'
                },
                {
                    id: 'Rules'
                },
                {
                    id: 'Decision trees'
                },
                {
                    id: 'Naive Bayes'
                },
                {
                    id: 'K nearest neighbor'
                },
                {
                    id: 'Probabilistic neural network'
                },
                {
                    id: 'Support vector machine'
                }
            ]
        },
        {
            id: 'Consensus',
            children: [
                {
                    id: 'Models diversity',
                    children: [
                        {
                            id: 'Different initializations'
                        },
                        {
                            id: 'Different parameter choices'
                        },
                        {
                            id: 'Different architectures'
                        },
                        {
                            id: 'Different modeling methods'
                        },
                        {
                            id: 'Different training sets'
                        },
                        {
                            id: 'Different feature sets'
                        }
                    ]
                },
                {
                    id: 'Methods',
                    children: [
                        {
                            id: 'Classifier selection'
                        },
                        {
                            id: 'Classifier fusion'
                        }
                    ]
                },
                {
                    id: 'Common',
                    children: [
                        {
                            id: 'Bagging'
                        },
                        {
                            id: 'Boosting'
                        },
                        {
                            id: 'AdaBoost'
                        }
                    ]
                }
            ]
        },
        {
            id: 'Regression',
            children: [
                {
                    id: 'Multiple linear regression'
                },
                {
                    id: 'Partial least squares'
                },
                {
                    id: 'Multi-layer feedforward neural network'
                },
                {
                    id: 'General regression neural network'
                },
                {
                    id: 'Support vector regression'
                }
            ]
        }
    ]
};

export const treeData = {
    name: 'flare',
    children: [
        {
            name: 'data',
            children: [
                {
                    name: 'converters',
                    children: [
                        { name: 'Converters', value: 721 },
                        { name: 'DelimitedTextConverter', value: 4294 }
                    ]
                },
                {
                    name: 'DataUtil',
                    value: 3322
                }
            ]
        },
        {
            name: 'display',
            children: [
                { name: 'DirtySprite', value: 8833 },
                { name: 'LineSprite', value: 1732 },
                { name: 'RectSprite', value: 3623 }
            ]
        },
        {
            name: 'flex',
            children: [{ name: 'FlareVis', value: 4116 }]
        },
        {
            name: 'query',
            children: [
                { name: 'AggregateExpression', value: 1616 },
                { name: 'And', value: 1027 },
                { name: 'Arithmetic', value: 3891 },
                { name: 'Average', value: 891 },
                { name: 'BinaryExpression', value: 2893 },
                { name: 'Comparison', value: 5103 },
                { name: 'CompositeExpression', value: 3677 },
                { name: 'Count', value: 781 },
                { name: 'DateUtil', value: 4141 },
                { name: 'Distinct', value: 933 },
                { name: 'Expression', value: 5130 },
                { name: 'ExpressionIterator', value: 3617 },
                { name: 'Fn', value: 3240 },
                { name: 'If', value: 2732 },
                { name: 'IsA', value: 2039 },
                { name: 'Literal', value: 1214 },
                { name: 'Match', value: 3748 },
                { name: 'Maximum', value: 843 },
                {
                    name: 'methods',
                    children: [
                        { name: 'add', value: 593 },
                        { name: 'and', value: 330 },
                        { name: 'average', value: 287 },
                        { name: 'count', value: 277 },
                        { name: 'distinct', value: 292 },
                        { name: 'div', value: 595 },
                        { name: 'eq', value: 594 },
                        { name: 'fn', value: 460 },
                        { name: 'gt', value: 603 },
                        { name: 'gte', value: 625 },
                        { name: 'iff', value: 748 },
                        { name: 'isa', value: 461 },
                        { name: 'lt', value: 597 },
                        { name: 'lte', value: 619 },
                        { name: 'max', value: 283 },
                        { name: 'min', value: 283 },
                        { name: 'mod', value: 591 },
                        { name: 'mul', value: 603 },
                        { name: 'neq', value: 599 },
                        { name: 'not', value: 386 },
                        { name: 'or', value: 323 },
                        { name: 'orderby', value: 307 },
                        { name: 'range', value: 772 },
                        { name: 'select', value: 296 },
                        { name: 'stddev', value: 363 },
                        { name: 'sub', value: 600 },
                        { name: 'sum', value: 280 },
                        { name: 'update', value: 307 },
                        { name: 'variance', value: 335 },
                        { name: 'where', value: 299 },
                        { name: 'xor', value: 354 },
                        { name: 'x_x', value: 264 }
                    ]
                },
                { name: 'Minimum', value: 843 },
                { name: 'Not', value: 1554 },
                { name: 'Or', value: 970 },
                { name: 'Query', value: 13896 },
                { name: 'Range', value: 1594 },
                { name: 'StringUtil', value: 4130 },
                { name: 'Sum', value: 791 },
                { name: 'Variable', value: 1124 },
                { name: 'Variance', value: 1876 },
                { name: 'Xor', value: 1101 }
            ]
        },
        {
            name: 'scale',
            children: [
                { name: 'IScaleMap', value: 2105 },
                { name: 'LinearScale', value: 1316 },
                { name: 'LogScale', value: 3151 },
                { name: 'OrdinalScale', value: 3770 },
                { name: 'QuantileScale', value: 2435 },
                { name: 'QuantitativeScale', value: 4839 },
                { name: 'RootScale', value: 1756 },
                { name: 'Scale', value: 4268 },
                { name: 'ScaleType', value: 1821 },
                { name: 'TimeScale', value: 5833 }
            ]
        }
    ]
};

export const importantLink = {
    1: '紧急且重要',
    2: '紧急但不重要',
    3: '不紧急但重要',
    4: '不紧急且不重要'
};

export const amountLink = {
    1: '开发',
    2: '上量',
    3: '回款'
};

export const page = {
    cust: {
        pageNum: 1,
        pageSize: 50,
        sizes: [50, 100, 200, 300]
    }
};

export const formatDate = (value, format = 'YYYY-MM-DD') => {
    return value ? moment(value).format(format) : '';
};

export const formatterName = (value, code) => {
    const store = useStore();
    const level = store.state.base.dictInfo[code];
    let obj = level.find(item => item.dictCode == value);
    if (obj) {
        return obj.dictName;
    } else {
        return '';
    }
};

export const setLineClamp = (element, lines) => {
    if (element.style.setProperty) {
        // 检查是否支持setProperty方法
        element.style.setProperty('--lines', lines); // 使用CSS变量定义行数
        element.style.display = '-webkit-box'; // 确保是WebKit盒模型
        element.style.overflow = 'hidden'; // 隐藏溢出的内容
        element.style.textOverflow = 'ellipsis'; // 显示省略号
        element.style.webkitBoxOrient = 'vertical'; // 设置盒模型的排列方向
        element.style.webkitLineClamp = lines; // 应用行数限制
    } else {
        // 对于不支持WebKit属性的浏览器，可以尝试其他方法，如使用纯JavaScript实现省略号效果。
    }
};

export const checkDateDays = async val => {
    const calendar = new HolidayCalendar();

    const getDateArray = () => {
        let datesArray = [];
        let currentDate = moment(val);
        let date = moment(val).startOf('isoWeek'); // 从周一的日期开始
        while (date.isSameOrBefore(currentDate, 'day')) {
            // 循环直到当前日期
            datesArray.push(date.clone().format('YYYY-MM-DD')); // 添加日期到数组中，使用clone避免修改原始日期对象
            date.add(1, 'days'); // 增加一天
        }
        return datesArray;
    };
    const dates = getDateArray();

    const alllist = dates.map(item => {
        async function get() {
            let res = await calendar.isHoliday('CN', item);
            return res;
        }
        const rs = get();
        return rs;
    });

    const res = await Promise.all(alllist);
    const isExt = res.filter(item => item);
    return {
        dates,
        isExt,
        res,
        currentDate: moment(val).format('YYYY-MM-DD'),
        isLink: isExt.length == dates.length
    };
};

export const generatePDF = element => {
    // const element = document.getElementById('myForm');

    html2canvas(element).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
            orientation: 'p',
            unit: 'in',
            format: 'letter'
        });
        pdf.addImage(imgData, 'PNG', 0, 0);
        pdf.save('download.pdf');
    });
};

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const ExportSavePdf = function (element, fileName = 'download') {
    html2canvas(element, {
        logging: false,
        scale: 1 // 缩放因子，提高图片清晰度
    }).then(canvas => {
        console.log(element.offsetWidth);

        const contentWidth = element.offsetWidth; // 获取元素宽度
        const contentHeight = element.offsetHeight; // 获取元素高度
        const pageData = canvas.toDataURL('image/jpeg', 1.0); // 将 canvas 转换为 base64 图片格式

        // 设置 PDF 的尺寸
        // const pdfWidth = (contentWidth * 0.75) / 2; // 转换为 pt 单位
        const pdfHeight = (contentHeight * 0.75) / 2 + 15; // 加上一定的底部留白

        // 初始化 jsPDF
        const pdf = new jsPDF('p', 'pt', 'a4');

        // 计算图片在 PDF 中的位置和尺寸
        const imgWidth = contentWidth - 20; // 图片宽度减去左右边距
        const imgHeight = (contentHeight * imgWidth) / contentWidth; // 根据图片宽高比计算图片高度
        pdf.addImage(pageData, 'JPEG', 10, 10, 1366, 800); // 将图片添加到 PDF 中
        pdf.save(`${fileName}.pdf`); // 保存 PDF 文件
    });
};

export const CheckChinaDay = val => {
    console.log(isHoliday(val));
};

export default link;
